module.exports = __webpack_public_path__ + "img/accelerograph.f08e46e6.png";